import type { MouseEvent, ReactNode } from "react";
import { Icon } from "../../shared/Icon";
import { If } from "../If";

interface ModalHeaderProps {
  children?: ReactNode;
  onClose?: (event: MouseEvent<HTMLAnchorElement>) => void;
}

export const ModalHeader = ({ onClose, children }: ModalHeaderProps) => {
  const _onClose = (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    onClose?.(event);
  };
  return (
    <div className="modal__header">
      {children}
      <If condition={!!onClose}>
        <a href="#close" onClick={_onClose} className="modal__close">
          <Icon type="close" />
        </a>
      </If>
    </div>
  );
};
